import React from 'react'
import './Testimonial.scss';

const Testimonial = () => {
  return (
    <>
      
    </>
  )
}

export default Testimonial